export const APP_TOUR_VERSION = 2;
export const APP_TOUR_STORAGE_KEY = '@biavent_app_tour';

/** Routes where the app tour should not auto-start */
export const APP_TOUR_EXCLUDED_ROUTE_PREFIXES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/onboarding',
  '/administrador',
  '/organizer',
];
